export default {
  oauth2: {
    clientId: '32447626072-ua10j0h7l43ckmqv8nij87napst6hlfc.apps.googleusercontent.com'
  }
};
